import { ArrowTopRightOnSquareIcon, LinkIcon } from '@heroicons/react/24/solid';

interface ExternalLinksListProps {
  repoName: string;
  hideGHLink?: boolean;
  hideRRLink?: boolean;
}

export function ExternalLinksList({repoName, hideGHLink = false, hideRRLink = true}: ExternalLinksListProps) {

  const encodedRepoName = encodeURIComponent(`${repoName}`);
  const depsDevURL = `https://deps.dev/project/github/${encodedRepoName.toLowerCase()}`; // needs lower case for this site

  const encodedRepoURL = encodeURIComponent(`https://github.com/${repoName}`);
  const repoMixURL = `https://repomix.com/?repo=${encodedRepoURL}`;

  // top 5 was giving GH API reate limit error
  // const top5RepoNames: string[] = [`${repoName}`].concat(sortedResults.slice(0,4).map(r => r.repo_name));
  // const starHistURL = `https://www.star-history.com/#${top5RepoNames.join('&')}`;
  const starHistURL = `https://www.star-history.com/#${repoName}`;

  /* later?: 
    https://scorecard.dev/viewer/?uri=github.com/ossf/scorecard
    https://deepwiki.com/karpathy/nanochat
    https://context7.com/anomalyco/opencode
    https://github.com/karpathy/rendergit (maybe github.dev is better for this use case?)
      https://rendergit.com/https://github.com/eden-chan/rendergit#top
      https://x.com/onlychans1/status/1958565838060999128?s=61&t=hB1dm_29aPu8GPXkd9dguw
    https://gitmcp.io/
    ossinsight.io - https://ossinsight.io/analyze/plotly/plotly.py
    https://libraries.io/
    chat with codebase - github.gg, talktogithub.com
    https://github.com/ahmedkhaleel2004/gitdiagram
    Try deep research to find other repo links?
  */

  return (<>

    {hideRRLink ? null : <p className="py-2">
      <a href={`https://relatedrepos.com/gh/${repoName}`} target="_blank" className="inline-flex items-center" aria-label={`View "${repoName}" on Related Repos`}>
        <span><span className='font-semibold text-rr-medium'>Related Repos</span> - Explore related projects</span>
        <ArrowTopRightOnSquareIcon className="inline-block size-4 text-gray-400 ml-1" />
      </a>
    </p>}

    {hideGHLink ? null : <p className="py-2">
      <a href={`https://github.com/${repoName}`} target="_blank" className="inline-flex items-center" aria-label={`View "${repoName}" on GitHub`}>
        <span><span className='font-semibold text-rr-medium'>GitHub</span> - View repository</span>
        <ArrowTopRightOnSquareIcon className="inline-block size-4 text-gray-400 ml-1" />
      </a>
    </p>}

    <p className="py-2">
      <a href={`https://github.dev/${repoName}`} target="_blank" className="inline-flex items-center" aria-label={`View "${repoName}" on GitHub.dev`}>
        <span><span className='font-semibold text-rr-medium'>GitHub.dev</span> - Open in online code editor</span>
        <ArrowTopRightOnSquareIcon className="inline-block size-4 text-gray-400 ml-1" />
      </a>
    </p>

    <p className="py-2">
      <a href={starHistURL} target="_blank" className="inline-flex items-center" aria-label={`View "${repoName}" on Star History`}>
        <span><span className='font-semibold text-rr-medium'>Star history</span> - Growth chart over time</span>
        <ArrowTopRightOnSquareIcon className="inline-block size-4 text-gray-400 ml-1" />
      </a>
    </p>

    <p className="py-2">
      <a href={depsDevURL} target="_blank" className="inline-flex items-center" aria-label={`View "${repoName}" on deps.dev`}>
        <span><span className='font-semibold text-rr-medium'>deps.dev</span> - Dependencies and security vulnerabilities</span>
        <ArrowTopRightOnSquareIcon className="inline-block size-4 text-gray-400 ml-1" />
      </a>
    </p>

    <p className="py-2">
      <a href={`https://gitingest.com/${repoName}`} target="_blank" className="inline-flex items-center" aria-label={`View "${repoName}" on Gitingest`}>
        <span><span className='font-semibold text-rr-medium'>Gitingest</span> - Export source code for LLM usage</span>
        <ArrowTopRightOnSquareIcon className="inline-block size-4 text-gray-400 ml-1" />
      </a>
    </p>

    <p className="py-2">
      <a href={repoMixURL} target="_blank" className="inline-flex items-center" aria-label={`View "${repoName}" on Gitingest`}>
        <span><span className='font-semibold text-rr-medium'>Repomix</span> - Export source code for LLM usage</span>
        <ArrowTopRightOnSquareIcon className="inline-block size-4 text-gray-400 ml-1" />
      </a>
    </p>

    <p className="py-2">
      <a href={`https://uithub.com/${repoName}`} target="_blank" className="inline-flex items-center" aria-label={`View "${repoName}" on uithub`}>
        <span><span className='font-semibold text-rr-medium'>uithub</span> - Export source code for LLM usage</span>
        <ArrowTopRightOnSquareIcon className="inline-block size-4 text-gray-400 ml-1" />
      </a>
    </p>
  </>);
}